export enum PushNotificationSubject {
    FEEDBACK = 'feedback',
    MESSAGE = 'message',
    REVIEW = 'review',
    POST = 'post',
    GLOBAL = 'global',
    REMINDER = 'reminder',
}
